(function(){
     'use strict';

     angular
        .module('appback')
        .factory('ExternalizadasService', ExternalizadasService);

    ExternalizadasService.$inject = ['$http'];

    function ExternalizadasService($http){


        var service= {
           guardar:guardar
        };

        return service;

        function guardar(filtros,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({ 
                filtros:JSON.stringify(filtros) 
            });
            $http.post('/backend/externalizadas/guardar',data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }


    }
})();